import { useRef, useState } from 'react';
import { BlogCard, Box, Button, Container, Hidden, IndicatorDots, MetaPill } from '@doist/marketist';
import cn from 'clsx';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useTranslation } from 'next-i18next';
import appendUTM from 'services/appendUTM';
import css from './blog-section.module.css';
function CategoryPill() {
  return <MetaPill size="small" href="https://todoist.com/inspiration/category/todoist" data-sentry-element="MetaPill" data-sentry-component="CategoryPill" data-sentry-source-file="blog-section.tsx">
            Todoist
        </MetaPill>;
}
export default function BlogSection({
  utm_campaign
}: {
  utm_campaign?: string;
}) {
  const {
    t
  } = useTranslation('helpcenter');
  const $scrollContainer = useRef<HTMLUListElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const blogPosts = [{
    title: t('blogSection.useTodoistEffectively.title'),
    description: t('blogSection.useTodoistEffectively.description'),
    src: 'https://images.ctfassets.net/dm4oa8qtogq0/6G1zoydztTk3Yj4p89URE5/2ed739bf06892a8bc1069930bba15bfa/use-todoist-effectively_2x.jpg',
    href: appendUTM('https://blog.doist.com/how-to-use-todoist-effectively', {
      utm_campaign
    }),
    pills: [<CategoryPill key="1" />]
  }, {
    title: t('blogSection.todoistFeatures.title'),
    description: t('blogSection.todoistFeatures.description'),
    src: 'https://images.ctfassets.net/dm4oa8qtogq0/22xNOnAhcfmq2nnrNGxyqD/c900f1de94bb4def430ac15e0a7546c5/todoist-features_2x.jpg',
    href: appendUTM('https://blog.doist.com/hidden-features-todoist', {
      utm_campaign
    }),
    pills: [<CategoryPill key="2" />]
  }, {
    title: t('blogSection.todoistSections.title'),
    description: t('blogSection.todoistSections.description'),
    src: 'https://images.ctfassets.net/dm4oa8qtogq0/2MmlxON5H6v25QVgmZIBqb/ad8f443489a58bdc5594031c2d6cec19/todoist-sections_2x.jpg',
    href: appendUTM('https://blog.doist.com/todoist-sections', {
      utm_campaign
    }),
    pills: [<CategoryPill key="3" />]
  }];
  function onSelectIndex(index: number) {
    if ($scrollContainer.current) {
      const scrollWidth = $scrollContainer.current.scrollWidth;
      const itemWidth = scrollWidth / blogPosts.length;
      $scrollContainer.current.scrollTo({
        left: itemWidth * index,
        behavior: 'smooth'
      });
    }
    setActiveIndex(index);
  }
  return <Box className={cn(css.blogSection, 'pbe-96 md-pbe-128')} data-sentry-element="Box" data-sentry-component="BlogSection" data-sentry-source-file="blog-section.tsx">
            <Container padded data-sentry-element="Container" data-sentry-source-file="blog-section.tsx">
                <Box className={css.heading} data-sentry-element="Box" data-sentry-source-file="blog-section.tsx">
                    <SectionHeader style={{
          '--section-mb': 'var(--space-64)'
        }} className={css.heading} title={t('blogSection.title')} subtitle={t('blogSection.description')} button={<Button href="/inspiration">{t('blogSection.visitHub')}</Button>} data-sentry-element="SectionHeader" data-sentry-source-file="blog-section.tsx" />
                </Box>
            </Container>

            <Box tag="ul" className={cn(css.horizontalScroll, 'pis-12 lg-pis-0 pbe-16')} ref={$scrollContainer} data-sentry-element="Box" data-sentry-source-file="blog-section.tsx">
                {blogPosts.map(post => <Box tag="li" key={post.title} className={cn(css.blogCard, css.column)}>
                        <BlogCard {...post} alt="">
                            {post.description}
                        </BlogCard>
                    </Box>)}
            </Box>
            <Hidden above="md" data-sentry-element="Hidden" data-sentry-source-file="blog-section.tsx">
                <IndicatorDots activeIndex={activeIndex} labels={blogPosts.map(post => post.title)} onSelectIndex={onSelectIndex} data-sentry-element="IndicatorDots" data-sentry-source-file="blog-section.tsx" />
            </Hidden>
        </Box>;
}